{
  "Mon": "Th 2",
  "Tue": "Th 3",
  "Wed": "Th 4",
  "Thu": "Th 5",
  "Fri": "Th 6",
  "Sat": "Th 7",
  "Son": "CN"
}
